import React, { useState } from 'react'
import { Button, makeStyles, Typography } from '@material-ui/core'
import { isMobile } from 'react-device-detect'
import HelpRounded from '@material-ui/icons/HelpRounded'
import RiskEventTooltipModal from './RiskEventTooltipModal'
import FundamentalTooltipModal from './FundamentalTooltipModal'
import BehaviouralTooltipModal from './BehaviouralTooltipModal'
import FundamentalCreditTooltipModal from './FundamentalCreditTooltipModal'

const useStyles = makeStyles({
  section: {
    padding: '0px 0px 10px 0px',
    marginBottom: '10px',
    background: 'white',
    borderRadius: 5,
    boxSizing: 'border-box',
  },
  sectionCustom: {
    padding: '16px 16px 0px 16px',
    marginBottom: '10px',
    background: 'white',
    borderRadius: 5,
    boxSizing: 'border-box',
    border: '1px solid #DFE4EB',
  },
  title: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 600,
    fontSize: 20,
    lineHeight: '24px',
    letterSpacing: 0,
    color: '#181818',
    marginRight: 5,
    display: 'inline-flex',
    alignItems: 'center',
  },
  titleCustom: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '22px',
    letterSpacing: 0,
    color: '#181818',
    marginRight: 5,
    display: 'inline-flex',
    alignItems: 'center',
  },
  titleMobile: {
    fontWeight: 400,
    color: '#181818',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  leftSection: {
    display: 'flex',
    alignItems: 'center',
  },
  leftSectionCustom: {
    display: 'flex',
    alignItems: 'center',
  },
  leftMobileSection: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    alignItems: 'flexStart',
    width: '100%',
  },
  iconMobileFlex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 20,
    height: 20,
    flex: '0 0 20px',
    textAlign: 'center',
  },
  toolTip: {
    color: '#8D9CB1',
    width: 16,
    height: 16,
    fontSize: 16,
    cursor: 'pointer',
    verticalAlign: 'middle',
    marginLeft: 3,
  },
  toolTipMobile: {
    color: '#8D9CB1',
    width: '20px !important',
    height: '20px !important',
    fontSize: '20px !important',
    cursor: 'pointer',
    verticalAlign: 'middle',
    marginLeft: 5,
  },
  impliedRating: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginLeft: 50,
    fontSize: 20,
  },
  impliedRatingRight: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginLeft: 'auto',
    textAlign: 'right',
  },
  impliedRatingLabel: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '18px',
    letterSpacing: 0,
    color: '#757575',
  },
  impliedRatingValue: {
    minWidth: 44,
    height: 26,
    borderRadius: 4,
    padding: '2px 8px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#F5F5F5',
    color: '#1B3963',
    fontFamily: 'Inter, sans-serif',
    fontWeight: 600,
    fontSize: 12,
    lineHeight: '18px',
    letterSpacing: 0,
  },
  subTitle: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontSize: 18,
    lineHeight: '26px',
    letterSpacing: 0,
    color: '#757575',
    marginTop: 0,
    display: 'inline-flex',
    alignItems: 'center',
  },
  subTitleCustom: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '22px',
    letterSpacing: 0,
    color: '#757575',
    marginTop: 0,
    display: 'inline-flex',
    alignItems: 'center',
  },
  subTitleMobile: {
    fontSize: 10,
    fontWeight: 600,
    color: '#757575',
  },
  head: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    // borderBottom: '1px solid #DFE4EB',
  },
  headCustom: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #DFE4EB',
  },
  mobileHead: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    borderBottom: '1px solid #DFE4EB',
  },
  mobileHeadCustom: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    borderBottom: '1px solid #DFE4EB',
  },
  statusMobile: {
    color: '#000',
    display: 'flex',
    alignItems: 'center',
    marginTop: '10px',
    '& div': {
      fontWeight: 600,
      fontSize: '16px !important',
    },
  },
  status: {
    color: '#000',
    display: 'flex',
    alignItems: 'center',
    marginLeft: '10px !important',
    '& div': {
      fontWeight: 600,
      fontSize: '16px !important',
      marginLeft: 10,
    },
  },
  circle: {
    height: 8,
    width: 8,
    borderRadius: '50%',
    position: 'relative',
    '& > div': {
      height: 16,
      width: 16,
      opacity: '0.35',
      borderRadius: '50%',
      position: 'absolute',
      left: '-4px',
      top: '-4px',
      margin: 0,
      'animation-name': `$backgroundColorPalette`,
      'animation-duration': '1s',
      'animation-iteration-count': 'infinite',
      'animation-direction': 'alternate',
      'animation-timing-function': 'liner',
    },
  },
  '@keyframes backgroundColorPalette': {
    '0%': {
      opacity: 0.25,
    },
    '25%': {
      opacity: 0.45,
    },
    '50%': {
      opacity: 0.55,
    },
    '75%': {
      opacity: 0.45,
    },
    '100%': {
      opacity: 0.25,
    },
  },
  button: {
    cursor: 'pointer',
    verticalAlign: 'text-top',
    marginLeft: 5,
    height: '20px',
    color: '#fff',
    backgroundColor: '#1B3963',
    whiteSpace: 'nowrap',
    textTransform: 'capitalize',
    fontWeight: 600,
    fontSize: 8,
    padding: '2px 3px',
    '&:hover': {
      backgroundColor: '#1B3963',
      color: '#fff',
    },
  },
})

interface PageSectionProps {
  title: string
  subTitle?: string
  children: any
  customStyle: any
  riskEventToolTip: boolean
  fundamentalTooltip: boolean
  behaviouralToolTip: boolean
  fundamentalCreditTooltip: boolean
  companyInfo?: any
  showImpliedRating?: boolean
  isShowingRisk?: boolean
  riskStatus?: any
  disableMinWidth?: boolean
  isCustom?: boolean
}

const PageSection = ({
  title,
  subTitle,
  children,
  customStyle,
  riskEventToolTip,
  fundamentalTooltip,
  fundamentalCreditTooltip,
  behaviouralToolTip,
  companyInfo,
  showImpliedRating,
  isShowingRisk,
  riskStatus,
  disableMinWidth,
  isCustom,
}: PageSectionProps) => {
  const classes = useStyles()
  const [openTooltip, setOpenTooltip] = React.useState(false)
  const handleClickOpenTooltip = () => {
    setOpenTooltip(true)
  }

  return (
    <>
      <section
        className={isCustom ? classes.sectionCustom : classes.section}
        style={
          isMobile
            ? {
                ...customStyle,
                padding: '15px 12px',
                border: '1px solid #DFE4EB',
              }
            : disableMinWidth
            ? { ...customStyle }
            : { ...customStyle, minWidth: '1300px' }
        }
      >
        <div
          className={
            isMobile
              ? classes.mobileHead
              : isCustom
              ? classes.headCustom
              : classes.head
          }
          style={{ paddingBottom: '5px' }}
        >
          {!isMobile && (
            <>
              <div
                className={
                  isCustom ? classes.leftSectionCustom : classes.leftSection
                }
              >
                <Typography
                  className={isCustom ? classes.titleCustom : classes.title}
                >
                  {title}
                </Typography>
                {subTitle && (
                  <span
                    className={
                      isCustom ? classes.subTitleCustom : classes.subTitle
                    }
                  >
                    ({subTitle})
                  </span>
                )}
                {riskEventToolTip && (
                  <HelpRounded
                    className={
                      isMobile ? classes.toolTipMobile : classes.toolTip
                    }
                    key="1"
                    onClick={() => handleClickOpenTooltip()}
                  />
                )}
                {fundamentalTooltip && (
                  <HelpRounded
                    className={classes.toolTip}
                    key="1"
                    onClick={() => handleClickOpenTooltip()}
                  />
                )}
                {fundamentalCreditTooltip && (
                  <HelpRounded
                    className={classes.toolTip}
                    key="1"
                    onClick={() => handleClickOpenTooltip()}
                  >
                    Quick Guide
                  </HelpRounded>
                )}
                {behaviouralToolTip && (
                  <HelpRounded
                    className={classes.toolTip}
                    key="1"
                    onClick={() => handleClickOpenTooltip()}
                  />
                )}
              </div>
              {isShowingRisk && (
                <div className={classes.status}>
                  <div
                    className={classes.circle}
                    style={{
                      backgroundColor: riskStatus.color,
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: riskStatus.color,
                      }}
                    >
                      {' '}
                    </div>
                  </div>
                  <div
                    style={{
                      color: riskStatus.color,
                    }}
                    className="statusName"
                  >
                    {riskStatus.text}
                  </div>
                </div>
              )}
            </>
          )}

          {isMobile && (
            <div className={classes.leftMobileSection}>
              <Typography className={classes.titleMobile}>
                <div>
                  {title}
                  <p className={classes.subTitleMobile}>({subTitle})</p>
                </div>
                {riskEventToolTip && (
                  <div className={classes.iconMobileFlex}>
                    <HelpRounded
                      className={classes.toolTipMobile}
                      key="1"
                      onClick={() => handleClickOpenTooltip()}
                    />
                  </div>
                )}
                {fundamentalTooltip && (
                  <div className={classes.iconMobileFlex}>
                    <HelpRounded
                      className={classes.toolTipMobile}
                      key="1"
                      onClick={() => handleClickOpenTooltip()}
                    />
                  </div>
                )}
                {fundamentalCreditTooltip && (
                  <div className={classes.iconMobileFlex}>
                    <HelpRounded
                      className={classes.toolTipMobile}
                      key="1"
                      onClick={() => handleClickOpenTooltip()}
                    />
                  </div>
                )}
                {behaviouralToolTip && (
                  <div className={classes.iconMobileFlex}>
                    <HelpRounded
                      className={classes.toolTipMobile}
                      key="1"
                      onClick={() => handleClickOpenTooltip()}
                    />
                  </div>
                )}
              </Typography>
            </div>
          )}
          {!isMobile && children[0]}
          {!isMobile &&
            showImpliedRating &&
            companyInfo &&
            companyInfo.bfaiRating && (
              <div
                className={classes.impliedRatingRight}
                // the id indicates this element is ignored when generating pdf
                id="impliedRatingInfo"
              >
                <span className={classes.impliedRatingLabel}>
                  Implied Rating
                </span>
                <span className={classes.impliedRatingValue}>
                  {companyInfo.bfaiRating}
                </span>
              </div>
            )}
          {isMobile && children[0]}
          {isMobile && isShowingRisk && (
            <div className={classes.statusMobile}>
              <div
                style={{
                  color: riskStatus.color,
                  marginRight: 10,
                }}
                className="statusName"
              >
                {riskStatus.text}
              </div>
              <div
                className={classes.circle}
                style={{
                  backgroundColor: riskStatus.color,
                }}
              >
                <div
                  style={{
                    backgroundColor: riskStatus.color,
                  }}
                >
                  {' '}
                </div>
              </div>
            </div>
          )}
        </div>
        {children[1]}
      </section>
      {riskEventToolTip && (
        <RiskEventTooltipModal
          open={openTooltip}
          handleClose={() => {
            setOpenTooltip(false)
          }}
        />
      )}
      {fundamentalTooltip && (
        <FundamentalTooltipModal
          open={openTooltip}
          handleClose={() => {
            setOpenTooltip(false)
          }}
        />
      )}
      {fundamentalCreditTooltip && (
        <FundamentalCreditTooltipModal
          open={openTooltip}
          handleClose={() => {
            setOpenTooltip(false)
          }}
        />
      )}
      {behaviouralToolTip && (
        <BehaviouralTooltipModal
          open={openTooltip}
          handleClose={() => {
            setOpenTooltip(false)
          }}
        />
      )}
    </>
  )
}

export default PageSection
